const Items = [
  {
    id: 1,
    mainImage:
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716013392/f1_hnejoy.jpg",
    img: [
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716013396/f8_uaqszk.jpg",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716013397/f9_mcyzva.jpg",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716013391/f2_h0swcr.jpg",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716013391/f4_lyp1vf.jpg",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716013391/f3_rkudzu.jpg",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716013391/f5_ofjzgs.jpg",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716013392/f6_u0thyd.jpg",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716013392/f7_fdiz8e.jpg",
    ],
    features: [
      "User Authentication",
      "Exercise Entry",
      "Workout History",
      "Edit/Delete Workouts",
      "Progress Tracking",
      "Search/Filter Workouts",
      "Summary Dashboard",
      "REST API",
      "404 Page and many more.",
    ],
    technologies: [
      "React",
      "TailwindCSS",
      "React Hooks",
      "React icons",
      "Express.js",
      "Node.js",
      "MongoDB",
    ],
    title: "Fitness Tracker",
    description:
      "A fitness tracker website is a digital platform designed to help users monitor and improve their health and fitness. It offers features such as activity tracking, workout logging, nutritional monitoring, and progress analysis. Users can set fitness goals, track their physical activities (like steps, running, cycling), log their meals and water intake, and receive personalized workout plans. The website often includes integration with wearable fitness devices and provides detailed reports and visualizations to help users stay motivated and achieve their fitness objectives. Additionally, social features allow users to share achievements and compete with friends, fostering a supportive fitness community.",
    category: "business",
    liveLink: "https://finesstrcker.vercel.app/",
    codeLink:
      "https://github.com/dhrupal0033/Fitness-Tracker-MERN/tree/main/fitness-tracker-MERN",
  },
  {
    id: 2,
    mainImage:
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1728109093/Screenshot_2024-10-05_113455_po1ei5.png",
    img: [
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1728109093/Screenshot_2024-10-05_113351_y3unap.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1728109093/Screenshot_2024-10-05_113306_pqkuvd.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1728109093/Screenshot_2024-10-05_113455_po1ei5.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1728109093/Screenshot_2024-10-05_113631_sdxeed.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1728109093/Screenshot_2024-10-05_113744_yx3mbt.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1728109094/Screenshot_2024-10-05_114156_qzjrgb.png",
    ],
    features: [
      "User registration and login",
      "Authentication using JWT Tokens",
      "Real-Time Messaging",
      "Private Messaging",
      "Typing Indicators",
      "Read Receipts",
      "File Sharing",
      "Push Notifications",
      "Message Search",
      "Message Encryption",
      "Media Sharing and Previews",
      "User Profiles",
      "Voice and Video Calls",
      "Responsive Design",
      "404 Page and many more.",
    ],
    technologies: [
      "React",
      "React Hooks",
      "Socket.IO",
      "Context API",
      "Axios",
      "SCSS",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
      "Mongoose",
      "Express Asynsc Handler",
      "Json Web Token",
      "Bcryptjs",
      "Dontenv",
      "Redis ",
      "Cors",
    ],
    title: "SwiftTalk - A Real Time Chat Web App",
    description:
      "A real-time chat web application allows users to send instant messages, share files, and communicate in private or group chats with features like typing indicators, read receipts, and push notifications.",
    category: "Business",
    liveLink: "https://swift-talk-xi.vercel.app/",
    codeLink: "https://github.com/dhrupal0033/SwiftTalk.git",
  },
  {
    id: 3,
    mainImage:
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312778/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-1_lcun2a.png",
    img: [
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312778/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-1_lcun2a.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312777/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-2_ar1fex.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312780/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-3_qpebgb.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312777/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-4_yadwtg.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312780/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-5_xvx0vj.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312773/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-6_aaq4yf.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312773/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-8_njclct.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312774/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-9_zg1jfe.png",
      "https://res.cloudinary.com/du541igfh/image/upload/v1684312772/Blog%20Portfolio%20Gilbert/Project/mern-movie/img-10_yag7bj.png",
    ],
    features: [
      "User registration and login",
      "Authentication using JWT Tokens",
      "Add Favorites",
      "Delete Favorites",
      "Leave a Reviews",
      "Delete Reviews",
      "Password Update",
      "Search Live",
      "Watch the trailer on Youtube",
      "404 Page and many more",
      "Skeleton loading effect",
      "DarkMode",
      "DarkMode",
      "Responsive Design",
    ],
    technologies: [
      "React",
      "React Hooks",
      "React Router Dom",
      "Axios",
      "Material UI",
      "CK Editor",
      "Formik",
      "React Redux",
      "React Toastify",
      "Swiper",
      "NodeJS",
      "ExpressJS",
      "Mongoose",
      "Json Web Token",
      "Cookie Parser",
      "Cors",
      "Dontenv",
      "Express Validator",
      "Nodemon",
      "MongoDB",
      "TMDB API",
    ],
    title: "BertFlix",
    description:
      "Fullstack open source movie application made with MongoDB, Express, React & Nodejs (MERN)",
    category: "personal",
    liveLink: "https://bertflix.vercel.app/",
    codeLink: "https://github.com/dhrupal0033/movie.git",
  },
  {
    id: 4,
    mainImage:
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021071/1_nlop9l.png",
    img: [
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021070/4_zwpqjw.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021070/5_zcvwo8.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021090/6_f8txx9.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021072/2_r5erna.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021090/7_pifxpy.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021091/8_d8c9b5.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021091/9_pll5ao.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021092/11_txlrnb.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021091/10_zoknt4.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021091/13_vajcjq.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021092/14_pwao9x.png",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021092/15_paly6h.png",
    ],
    features: [
      "💻 Real-time collaboration on code editing across multiple files",
      "🚀 Unique room generation with room ID for collaboration",
      "🌈 Syntax highlighting for various file types with auto-language detection",
      "💡 Auto suggestion based on programming language",
      "⏱️ Instant updates and synchronization of code changes across all files",
      "📣 Notifications for user join and leave events",
      "🎨 Multiple themes for personalized coding experience",
      "🌍 Comprehensive language support for versatile programming",
      "🔠 Option to change font size and font family",
      "👥 User presence list of users currently in the collaboration session, including online/offline status indicators",
      "📁 Open, edit, save, and delete file functionalities",
      "💾 Option to download files edited within the collaboration session",
      "💬 Group chatting allows users to communicate in real-time while working on code.",
      "🎩 Real-time tooltip displaying users currently editing",
    ],
    technologies: [
      "React",
      "React Router",
      "Tailwind CSS",
      "JavaScript",
      "Node JS",
      "Express JS",
      "Git",
      "Github",
      "Vercel",
    ],
    title: "Code_Sync, A Real Time Code Editor",
    description:
      "The process Code Sync is an innovative, web-based collaborative coding environment designed to facilitate real-time interaction among software developers.",
    category: "business",
    liveLink: "https://code-sync-flame.vercel.app/",
    codeLink: "https://github.com/dhrupal0033/Code_Sync.git",
  },
  // {
  //   id: 5,
  //   mainImage:
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-1_yhedpu.png",
  //   img: [
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-1_yhedpu.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-2_uktrxk.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-3_s1js9i.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869747/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-4_sb9ga6.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683869748/Blog%20Portfolio%20Gilbert/Project/mern-student-management-system/img-5_wrxlr7.png",
  //   ],
  //   features: [
  //     "Add Student",
  //     "Edit Student",
  //     "Remove Student",
  //     "No Student Page",
  //     "Responsive Design",
  //     "404 Page and many more",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Hooks",
  //     "React Router Dom",
  //     "Axios",
  //     "Bootstrap",
  //     "React Icons",
  //     "Sweet Alert2",
  //     "Node JS",
  //     "Express JS",
  //     "Cors",
  //     "Mongoose",
  //     "Dotenv",
  //     "Nodemon",
  //     "MongoDB",
  //   ],
  //   title: "Student Management System",
  //   description:
  //     "Fullstack open source student management system application made with MongoDB, Express, React & Nodejs (MERN)",
  //   category: "business",
  //   liveLink: "https://sttiss.vercel.app/",
  //   codeLink: "https://github.com/dhrupal0033/mern-student-management-system",
  // },
  {
    id: 6,
    mainImage:
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021780/g2_gofmp6.jpg",
    img: [
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021777/g1_wbwtui.jpg",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021780/g2_gofmp6.jpg",
      "https://res.cloudinary.com/dvw5uvexs/image/upload/v1716021779/g3_wjwgb6.jpg",
    ],
    features: [
      "Mobile Responsive",
      "Beautiful Animations",
      "Rapid Controls",
      "High Score",
      "Mario Background Music",
      "Jump & Game Over Sound Effect",
    ],
    technologies: [
      "React",
      "CSS",
      "React Hooks",
      "React Router",
      "React Redux",
    ],
    title: "Mario Jump",
    description:
      "Mario Jump is an endless running game inspired by the famous Google Chrome's T-Rex Dinosaur Game 🦖. The game is built entirely with ReactJS ⚛ and Redux Toolkit 🔧.",
    category: "game",
    liveLink: "https://mariojumpp.vercel.app/",
    codeLink: "https://github.com/dhrupal0033/mario-jump-game",
  },
  // {
  //   id: 7,
  //   mainImage:
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682944695/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-3_t6uxoj.png",
  //   img: [
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-1_gqero4.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-2_ukjdh2.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682944695/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-3_t6uxoj.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-4_btevir.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-5_oakjx2.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682944092/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-6_pqefy9.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1682944091/Blog%20Portfolio%20Gilbert/Project/bert-quiz/img-7_wfrvb7.png",
  //   ],
  //   features: [
  //     "User registration and login",
  //     "Select the type of question and the difficulty level of the question",
  //     "Juis time is running and after the time is up it stops automatically",
  //     "The final results of the answers answered will be shown",
  //     "Incorrect and correct answer results will be displayed",
  //     "Responsive Design",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Vite",
  //     "Tailwind CSS",
  //     "Firebase Authentication",
  //     "Framer Motion",
  //     "React Firebase Hooks",
  //     "React Icons",
  //   ],
  //   title: "Bert Quiz",
  //   description: "Fullstack open source quiz application",
  //   category: "personal",
  //   liveLink: "https://bertquiz.vercel.app/",
  //   codeLink: "https://github.com/dhrupal0033/react-quiz",
  // },
  // {
  //   id: 8,
  //   mainImage:
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-1_q5d6pn.png",
  //   img: [
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-1_q5d6pn.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033411/Blog%20Portfolio%20Gilbert/Project/shopify/img-2_nko9ic.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033413/Blog%20Portfolio%20Gilbert/Project/shopify/img-3_rnhbr1.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-4_ks8lck.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033409/Blog%20Portfolio%20Gilbert/Project/shopify/img-5_eotroj.png",
  //     "https://res.cloudinary.com/du541igfh/image/upload/v1683033408/Blog%20Portfolio%20Gilbert/Project/shopify/img-6_fgpzef.png",
  //   ],
  //   features: [
  //     "Mobile Responsive",
  //     "Beautiful Animations",
  //     "Product",
  //     "Pricing",
  //     "Testimonial",
  //     "Contact",
  //   ],
  //   technologies: [
  //     "React",
  //     "React Vite",
  //     "Tailwind CSS",
  //     "Framer Motion",
  //     "React Icons",
  //     "React Hooks",
  //   ],
  //   title: "Shopify",
  //   description: "Open source landing page shopify application",
  //   category: "personal",
  //   liveLink: "https://shopifyy.vercel.app/",
  //   codeLink: "https://github.com/dhrupal0033/react-shopify-landing",
  // },
];

export default Items;
